import { ADD_LOGIN_DATA, REMOVE_ITEM, RESET_LOGIN_DATA } from './actionTypes';

interface LoginData {
  id: string;
  username: string;
  authToken: string;
  otpToken: string;
  verifyOtpToken: string;
  name: string;
  role: string;
}

interface Item {
  id: string;
  [key: string]: unknown;
}

interface AppState {
  items: Item[];
  loginData: LoginData;
}

type AppAction =
  | { type: typeof ADD_LOGIN_DATA; payload: Partial<LoginData> }
  | { type: typeof REMOVE_ITEM; payload: string }
  | { type: typeof RESET_LOGIN_DATA };

const initialState: AppState = {
  items: [],
  loginData: {
    id: "",
    username: "",
    authToken: "",
    otpToken: "",
    verifyOtpToken: "",
    name: "",
    role: "",
  },
};

const itemReducer = (state: AppState = initialState, action: AppAction): AppState => {
  switch (action.type) {
    case ADD_LOGIN_DATA:
      return {
        ...state,
        loginData: { ...state.loginData, ...action.payload },
      };
    case REMOVE_ITEM:
      return {
        ...state,
        items: state.items.filter((item) => item.id !== action.payload),
      };
    case RESET_LOGIN_DATA:
      return {
        ...state,
        loginData: initialState.loginData,
      };
    default:
      return state;
  }
};

export default itemReducer;
